/* 路过图床 */
/*
const gonghuijia = [
    { "Id":1, "Img": "https://s2.ax1x.com/2019/08/21/mtLNtA.jpg", "Remark": "工会加1" },
    { "Id":2, "Img": "https://s2.ax1x.com/2019/08/21/mtLBX8.jpg", "Remark": "工会加2" },
    { "Id":3, "Img": "https://s2.ax1x.com/2019/08/21/mtLUfI.jpg", "Remark": "工会加3" },
    { "Id":4, "Img": "https://s2.ax1x.com/2019/08/21/mtLckj.jpg", "Remark": "工会加4" },
    { "Id":5, "Img": "https://s2.ax1x.com/2019/08/21/mtL06f.jpg", "Remark": "工会加5" },
    { "Id":6, "Img": "https://s2.ax1x.com/2019/08/21/mtLdpt.jpg", "Remark": "工会加6" },
    { "Id":7, "Img": "https://s2.ax1x.com/2019/08/24/m63XLV.jpg", "Remark": "工会加7" },
    { "Id":8, "Img": "https://s2.ax1x.com/2019/08/21/mtLw1P.jpg", "Remark": "工会加8" }
]

const xingdongyijia = [
    { "Id":1, "Img":"https://s2.ax1x.com/2019/08/24/m63ib8.jpg", "Remark":"星动壹加-公益揭牌" },
    { "Id":2, "Img":"https://s2.ax1x.com/2019/08/24/m63PDf.jpg", "Remark":"星动壹加-公益长跑1" },
    { "Id":3, "Img":"https://s2.ax1x.com/2019/08/24/m6lDOK.jpg", "Remark":"星动壹加-公益长跑2" },
    { "Id":4, "Img":"https://s2.ax1x.com/2019/08/24/m63kVS.jpg", "Remark":"星动壹加-公益长跑3" },
    { "Id":5, "Img":"https://s2.ax1x.com/2019/08/24/m63AUg.jpg", "Remark":"星动壹加-公益长跑4" },
    { "Id":6, "Img":"https://s2.ax1x.com/2019/08/24/m63E5Q.jpg", "Remark":"星动壹加-尊老1" },
    { "Id":7, "Img":"https://s2.ax1x.com/2019/08/24/m63e8s.jpg", "Remark":"星动壹加-尊老2" },
    { "Id":8, "Img":"https://s2.ax1x.com/2019/08/24/m63ZCj.jpg", "Remark":"星动壹加-尊老3" },
    { "Id":9, "Img":"https://s2.ax1x.com/2019/08/24/m63m2n.jpg", "Remark":"星动壹加-尊老4" },
    { "Id":10, "Img":"https://s2.ax1x.com/2019/08/24/m63SgI.jpg", "Remark":"星动壹加-爱幼" }
]

const haixingcun = [
    { "Id":1, "Img": "https://s2.ax1x.com/2019/08/24/m68Byq.jpg", "Remark": "海星村1" },
    { "Id":2, "Img": "https://s2.ax1x.com/2019/08/21/mtLs0g.jpg", "Remark": "海星村2" },
    { "Id":3, "Img": "https://s2.ax1x.com/2019/08/21/mtLy7Q.jpg", "Remark": "海星村3" },
    { "Id":4, "Img": "https://s2.ax1x.com/2019/08/21/mtLWpq.jpg", "Remark": "海星村4" },
    { "Id":5, "Img": "https://s2.ax1x.com/2019/08/24/m63CKP.jpg", "Remark": "海星村5" }
]
*/

/* 阿里云 */
const gonghuijia = [
    { "Id":1, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%B7%A5%E4%BC%9A/1_compressed.jpg", "Remark": "工会加1" },
    { "Id":2, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%B7%A5%E4%BC%9A/2_compressed.jpg", "Remark": "工会加2" },
    { "Id":3, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%B7%A5%E4%BC%9A/3_compressed.jpg", "Remark": "工会加3" },
    { "Id":4, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%B7%A5%E4%BC%9A/4_compressed.jpg", "Remark": "工会加4" },
    { "Id":5, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%B7%A5%E4%BC%9A/5_compressed.jpg", "Remark": "工会加5" },
    { "Id":6, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%B7%A5%E4%BC%9A/6_compressed.jpg", "Remark": "工会加6" },
    { "Id":7, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%B7%A5%E4%BC%9A/7_compressed.jpg", "Remark": "工会加7" },
    { "Id":8, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%B7%A5%E4%BC%9A/8_compressed.jpg", "Remark": "工会加8" },
    { "Id":9, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%B7%A5%E4%BC%9A/9_compressed.jpg", "Remark": "工会加9" },
    { "Id":10, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%B7%A5%E4%BC%9A/10_compressed.jpg", "Remark": "工会加10" }
]

const xingdongyijia = [
    { "Id":1, "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%98%9F%E5%8A%A8%E5%A3%B9%E5%8A%A0-%E5%85%AC%E7%9B%8A%E6%8F%AD%E7%89%8C.jpg", "Remark":"星动壹加-公益揭牌" },
    { "Id":2, "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%98%9F%E5%8A%A8%E5%A3%B9%E5%8A%A0-%E5%85%AC%E7%9B%8A%E9%95%BF%E8%B7%911.jpg", "Remark":"星动壹加-公益长跑1" },
    { "Id":3, "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%98%9F%E5%8A%A8%E5%A3%B9%E5%8A%A0-%E5%85%AC%E7%9B%8A%E9%95%BF%E8%B7%912.jpg", "Remark":"星动壹加-公益长跑2" },
    { "Id":4, "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%98%9F%E5%8A%A8%E5%A3%B9%E5%8A%A0-%E5%85%AC%E7%9B%8A%E9%95%BF%E8%B7%913.jpg", "Remark":"星动壹加-公益长跑3" },
    { "Id":5, "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%98%9F%E5%8A%A8%E5%A3%B9%E5%8A%A0-%E5%85%AC%E7%9B%8A%E9%95%BF%E8%B7%914.jpg", "Remark":"星动壹加-公益长跑4" },
    { "Id":5, "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E6%98%9F%E5%8A%A8%E5%A3%B9%E5%8A%A0.jpg", "Remark":"星动壹加-公益长跑5" },
    { "Id":6, "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%98%9F%E5%8A%A8%E5%A3%B9%E5%8A%A0-%E5%B0%8A%E8%80%811.jpg", "Remark":"星动壹加-尊老1" },
    { "Id":7, "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%98%9F%E5%8A%A8%E5%A3%B9%E5%8A%A0-%E5%B0%8A%E8%80%812.jpg", "Remark":"星动壹加-尊老2" },
    { "Id":8, "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%98%9F%E5%8A%A8%E5%A3%B9%E5%8A%A0-%E5%B0%8A%E8%80%813.jpg", "Remark":"星动壹加-尊老3" },
    { "Id":9, "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%98%9F%E5%8A%A8%E5%A3%B9%E5%8A%A0-%E5%B0%8A%E8%80%814.jpg", "Remark":"星动壹加-尊老4" },
    { "Id":10, "Img":"https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%98%9F%E5%8A%A8%E5%A3%B9%E5%8A%A0-%E7%88%B1%E5%B9%BC.jpg", "Remark":"星动壹加-爱幼" }
]

const haixingcun = [
    { "Id":1, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%B5%B7%E6%98%9F%E6%9D%911.jpg", "Remark": "海星村1" },
    { "Id":2, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%B5%B7%E6%98%9F%E6%9D%912.jpg", "Remark": "海星村2" },
    { "Id":3, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%B5%B7%E6%98%9F%E6%9D%913.jpg", "Remark": "海星村3" },
    { "Id":4, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%B5%B7%E6%98%9F%E6%9D%914.jpg", "Remark": "海星村4" },
    { "Id":5, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/%E6%B5%B7%E6%98%9F%E6%8B%9B%E8%81%98%E5%9B%BE%E7%89%87/%E6%B5%B7%E6%98%9F%E6%9D%915.jpg", "Remark": "海星村5" }
]

const xuexifenxiang = [
    { "Id":1, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%AD%A6%E4%B9%A0%E4%B8%8E%E5%88%86%E4%BA%AB/1_compressed.jpg", "Remark": "学习与分享1" },
    { "Id":2, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%AD%A6%E4%B9%A0%E4%B8%8E%E5%88%86%E4%BA%AB/2_compressed.jpg", "Remark": "学习与分享2" },
    { "Id":3, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%AD%A6%E4%B9%A0%E4%B8%8E%E5%88%86%E4%BA%AB/3_compressed.jpg", "Remark": "学习与分享3" },
    { "Id":4, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%AD%A6%E4%B9%A0%E4%B8%8E%E5%88%86%E4%BA%AB/4_compressed.jpg", "Remark": "学习与分享4" },
    { "Id":5, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%AD%A6%E4%B9%A0%E4%B8%8E%E5%88%86%E4%BA%AB/5_compressed.jpg", "Remark": "学习与分享5" },
    { "Id":6, "Img": "https://histar.oss-cn-shanghai.aliyuncs.com/2023-8-22/%E5%AD%A6%E4%B9%A0%E4%B8%8E%E5%88%86%E4%BA%AB/6_compressed.jpg", "Remark": "学习与分享6" }
]


export function getGongHuiJia() {
    return gonghuijia
}

export function getXingDongYiJia() {
    return xingdongyijia
}

export function getHaiXingCun() {
    return haixingcun
}

export function getXueXiFenXiang() {
    return xuexifenxiang
}



// WEBPACK FOOTER //
// ./src/mock/culture.js